import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client';
import { AUTH_TOKEN } from '../react/config';

const createApolloClient = (policies) => new ApolloClient({
  link: new HttpLink({
    uri: '/api',
    headers: {
      Authorization: `Bearer ${AUTH_TOKEN}`,
    },
  }),
  cache: new InMemoryCache({
    typePolicies: { ...policies },
  }),
});

export default createApolloClient;
